<app-import-theme-bar
  [mode]="mode$ | async"
  (changeMode)="changeMode($event)"
  (showThemeImport)="showedThemeImport = $event"
></app-import-theme-bar>
<div
  class="m-h-100vh relative"
  [ngClass]="mode$ | async"
  [class.show-import]="showedThemeImport"
>
  <div
    class="loader inner-right-img text-center"
    *ngIf="loading$ | async; else trackingNumbers"
  >
    <div>
      <img class="img-fluid" src="/assets/img/spinner.gif" />
      <p class="loading">Loading</p>
    </div>
  </div>
  <ng-template #trackingNumbers>
    <app-tracking-page
      [trackingPage]="trackingPage$ | async"
      [sideBarItemsOpened]="sideBarItemsOpened$ | async"
      [numbers]="numbers"
      [showDetails]="showDetails$ | async"
      [showDetailsLoading]="showDetailsLoading$ | async"
      [selectedItem]="selectedTrackingNumber$ | async"
      [sideBarItems]="sideBarItems$ | async"
      (submitReview)="updateReview($event)"
      (selectTrackingNumber)="selectTrackingNumber($event)"
      (toggleSideBarItemOpen)="toggleSideBarItemOpen($event)"
      [reviewEnabled]="reviewsEnabled$ | async"
      [loadMoreVisible]="isLoadMoreVisible$ | async"
      (changeLanguage)="changeLanguage($event)"
      (toggleDetails)="onToggleDetails($event)"
      (showMore)="showMoreSidebarItems()"
      [moreValues]="moreValues$ | async"
      [moreTrackingNumberValues]="moreTrackingNumberValues$ | async"
      [loadMoreTrackingNumbers]="loadMoreTrackingNumbersVisible$ | async"
      (triggerLoadMoreTrackingNumbers)="loadMoreTrackingNumbers()"
      [visualBuilder]="false"
      [mode]="mode$ | async"
      [checkpoints]="checkpoints$ | async"
    >
    </app-tracking-page>
  </ng-template>
</div>
